import AppRenderer from "../app_renderer";
import SpecialCharCheck from "../string_check/char_check";
import Debugger from "../console/debugger";
import PainterProxy from "../painter/proxy";
import { store } from "../../store";
import { useUserStore } from '../user_data';
import DEFINE from '../painter/define';
import { BOOK_TYPE } from '../book_define/book_type';
import { timeFormat } from '../../data/time_format';
import EventBus from '../event_bus';
import { settingStore } from "../store/settingStore";
import GraphicBoardProxy from "../painter/graphic_board_proxy";
import { VIEW_TYPE } from "../view_type";
import ImageControl from "../record_task/image_control";

export default class SaveTool {
    _promptDialog = null;
    _confirmDialog = null;
    _alertDialog = null;
    _saveDialog = null;
    _userRecordDialog = null;
    _loginTypeDialog = null;
    _mergeConfirm = null;
    _messageDialog = null;
    _specialCharCheck = new SpecialCharCheck();

    #repeatRecordId = "";

    _localSaveTempName = "";

    /**
     *
     * @type {SaveTool}
     * @memberof SaveTool
     */
    static _instance;
    constructor(prompt, confirm, alert, saveDialog, userRecordDialog, loginTypeDialog, mergeConfirm, messageDialog) {
        SaveTool._instance = this;
        this._promptDialog = prompt;
        this._confirmDialog = confirm;
        this._alertDialog = alert;
        this._saveDialog = saveDialog;
        this._userRecordDialog = userRecordDialog;
        this._loginTypeDialog = loginTypeDialog;
        this._mergeConfirm = mergeConfirm;
        this._messageDialog = messageDialog;
    }

    getToolFunction() {
        return [
            {
                key: "save_record",
                event: this.startSaveRecord()
            },
            {
                key: "load_record",
                event: this.getUserRecord()
            },
            {
                key: "member_login",
                event: this.handleLogin()
            },
            {
                key: "auto_save_local",
                event: this.startAutoSaveLocal()
            }
        ];
    }
    //#region 儲存使用者紀錄
    /**
     * 開始存檔
     *
     * @return {Function} 
     * @memberof SaveTool
     */
    startSaveRecord() {
        const self = this;
        return () => {
            self._saveDialog.showDialog();
        };
    }

    /**
     *
     *
     * @param {string} fileName
     * @memberof SaveTool
     */
    showLocalSaveDialog(fileName) {
        this._promptDialog.showDialog(
            "儲存班級紀錄", // title
            "名稱", //message
            this.handleNameSpecialCheck.bind(this), //confirm callback
            this.handleSaveAs.bind(this),
            fileName,
            "請在此輸入紀錄名稱，只允許中英數字與底線符號",
            store.mergeToCloud ? "本機儲存+雲端同步" : "本機儲存",
            "另存新檔",
            "blue",
            "light-orange"
        );
        this._localSaveTempName = fileName;
        this._promptDialog.setConfirmPrompt("(預設C槽)");
        this._promptDialog.setCancelPrompt("(自選位置)");
    }

    /**
     *
     * 檢查有沒有不合法的字元
     * @param {string} fileName user input record file name
     * @memberof SaveTool
     */
    handleNameSpecialCheck(fileName) {
        const self = this;
        if (!this.handleNameSpaceCheck(fileName)) {
            return;
        }
        if (this._specialCharCheck.checkSpecial(fileName)) {
            // here is fileName contains special char
            this._alertDialog.showDialog(
                "提示",
                "名稱只允許中英數字與底線符號",
                () => {
                    self._alertDialog.show = false;
                },
            );
        } else {
            // here is fileName not contains special char
            console.log("no special char");
            store.nowLogName = fileName;
            this.handleMergeToCloudCheck(fileName)
        }
    }
    /**
     * 
     * @param {string} fileName user input record file name
     * @returns true: length of [fileName] > 0; false: [fileName] is empty
     */
    handleNameSpaceCheck(fileName) {
        const self = this;
        if (fileName.length == 0) {
            this._alertDialog.showDialog(
                "提示",
                "存檔名稱不能空白",
                () => {
                    self._alertDialog.show = false;
                },
            );
            return false;
        }

        return true
    }

    /**
     *
     * 處理檔案名稱有無在本地的DB中重複
     * TIP : result為-1表示本機及雲端無重複，result.id為空的話表示不需更新本機紀錄
     * @param {{id:string, status:string}|number} result
     * @memberof SaveTool
     */
    handleNameRepeatCheck(result) {
        //Debugger.Instance.showLog("save_tool");
        Debugger.Instance.log(result, "save_tool");
        this._messageDialog.handleClose();

        if (result != -1) {
            // repeat log_name, show dialog
            if (result.status == "delete") {
                this.handleSave(result.id);
            } else {
                let handleCancel = null;
                if (this._localSaveTempName.length > 0) {
                    this._promptDialog.show = false;
                    handleCancel = this.showLocalSaveDialog.bind(this, this._localSaveTempName);
                }

                this._confirmDialog.showDialog(
                    "提示",
                    "檔案名稱重複將會覆蓋已經存在的資料",
                    this.handleSave.bind(this, result.id),
                    handleCancel
                );

                this.#repeatRecordId = result.id;

            }
        } else {
            // no repeat, go save file
            this.#repeatRecordId = "";
            this.handleSave();
        }
    }

    handleSaveAs(fileName) {
        store.nowLogName = fileName;
        const data = this.getSaveData();

        AppRenderer.Instance.saveAsRecord(data, store.nowLogName);
    }
    /**
     * 
     * @param {String} fileName name of user's record
     */
    handleMergeToCloudCheck(fileName) {
        if (store.mergeToCloud && store.nowView != VIEW_TYPE.WEB) {
            this._mergeConfirm.showDialog(fileName);
        } else {
            this._messageDialog.showDialog("紀錄進度", "檢查檔名中...");
            AppRenderer.Instance.getRepeatRecordId(fileName);
        }
    }

    showMergeConfirm() {
        if (this.#repeatRecordId.length > 0) {
            this._mergeConfirm.showDialog(this.#repeatRecordId);
        } else {
            this._mergeConfirm.showDialog();
        }
    }

    /**
     *
     * get user's record and send to save file
     * @param {String} uuid id of user's record
     * @memberof SaveTool
     */
    handleSave(uuid) {
        const data = this.getSaveData();

        Debugger.Instance.log(data, "save_tool");
        // const data = JSON.stringify(PainterProxy.getInstance().getMainPainterSaves());

        this._messageDialog.showDialog("紀錄進度", "存檔中...");

        if (uuid) {
            AppRenderer.Instance.updateRecord(uuid, data);
        } else {
            AppRenderer.Instance.saveRecord(store.nowLogName, data);
        }
    }

    getSaveData() {
        // PainterProxy.getInstance().clearExceptTarget();
        PainterProxy.getInstance().saveMainPainter(store.currentPaintSaveKey);

        const rawData = {};
        rawData.createTime = timeFormat(new Date());
        rawData.nowPage = store.nowPage;
        rawData.currentBookPage = store.currentBookPage;
        rawData.currentStudyPage = store.currentStudyPage;

        if (store.nowBook == BOOK_TYPE.BOOK) {
            rawData.currentBookPage = store.nowPage;
        } else if (store.nowBook == BOOK_TYPE.STUDY) {
            rawData.currentStudyPage = store.nowPage;
        }

        rawData.nowBook = store.nowBook;
        rawData.toolBar = store.tools;
        rawData.cursorSetting = store.cursorSetting;
        rawData.painterSetting = {};
        rawData.painterSetting.pen = PainterProxy.getInstance().getPainterSetting(DEFINE.OPERATE.PEN);
        rawData.painterSetting.highlighter = PainterProxy.getInstance().getPainterSetting(DEFINE.OPERATE.HIGHLIGHTER);
        rawData.painterSetting.laserPointer = PainterProxy.getInstance().getPainterSetting(DEFINE.OPERATE.LASER_POINTER);
        rawData.isFixed = settingStore.isFixed;
        rawData.images = ImageControl.Instance.getFiles;

        let tempUserPaint = PainterProxy.getInstance().getMainPainterSaves();
        let userPaint = this.recordParse(tempUserPaint);

        let tempGraphicPaint = GraphicBoardProxy.Instance.getGraphicBoardSave();
        let graphicPaint = this.recordParse(tempGraphicPaint);

        rawData.userPaint = userPaint;
        rawData.stampCustomPage = store.stampCustomPage;
        rawData.stampCustomIndex = store.stampCustomIndex;
        rawData.graphicPaint = graphicPaint;

        const data = JSON.stringify(rawData);
        return data;
    }

    showFinish(result) {
        this._messageDialog.handleClose();
        this._saveDialog.handleClose();
        this._promptDialog.show = false;
        if (result) {
            if (store.nowView != VIEW_TYPE.WEB) {
                this._confirmDialog.showDialog(
                    "紀錄進度",
                    "存檔完成",
                    () => { },
                    () => {
                        AppRenderer.Instance.exit();
                    },
                    "回到電子書",
                    "關閉電子書",
                    "blue",
                    "orange"
                );
            } else {
                this._alertDialog.showDialog(
                    "紀錄進度",
                    "存檔完成",
                    () => { },
                    "回到電子書",
                    "blue",
                );
            }
        } else {
            this._alertDialog.showDialog(
                "紀錄進度",
                "存檔失敗",
                () => { },
                "回到電子書",
                "blue",
            );
        }
    }

    /**
     * 取得使用者存檔紀錄
     *
     * @return {Function} 
     * @memberof SaveTool
     */
    getUserRecord() {
        // console.log("get user record");
        return () => {
            AppRenderer.Instance.getUserRecord();
        };
    }

    /**
     * 顯示使用者存檔紀錄
     *
     * @param {Object} data
     * @memberof SaveTool
     */
    showUserRecord(data, autoSaveData) {
        // console.table(data);
        this._userRecordDialog.setUserRecord(data, autoSaveData);
        this._userRecordDialog.show = true;
    }

    /**
     * load user record data by fetch
     *
     * @param {*} filePath
     * @memberof SaveTool
     */
    loadUserRecord(data, filePath) {
        const self = this;
        const folderPath = filePath.substring(0, filePath.lastIndexOf(".")) + "/";

        const userPaint = this.recordParseToRead(data.userPaint, folderPath);
        const graphicPaint = this.recordParseToRead(data.graphicPaint, folderPath);

        const nowPage = data.nowPage;
        const nowBook = data.nowBook;

        // 讀取劃記
        PainterProxy.getInstance().setMainPainterSaves(userPaint);
        let currPaintSave = PainterProxy.getInstance().getMainPainterSave(store.currentPaintSaveKey);
        if (currPaintSave) {
            // 如果讀檔的檔案有該頁的劃記才需要讀取
            PainterProxy.getInstance().loadMainPainter(currPaintSave);
            // 需讀取完才能跳轉
            PainterProxy.getInstance().getMainPainter().painter.onFinishLoadSave = () => {
                PainterProxy.getInstance().initHistory();
                window.pageControl.gotoPage(nowPage, nowBook);
            }
        } else {
            // 不須讀取則直接跳轉
            window.pageControl.gotoPage(nowPage, nowBook);
        }

        self._userRecordDialog.show = false;

        GraphicBoardProxy.Instance.setGraphicBoardSave(graphicPaint);
        // 還原工具列
        store.tools = data.toolBar;
        // 還原畫筆設定
        PainterProxy.getInstance().setPainterSetting(DEFINE.OPERATE.PEN, data.painterSetting.pen);
        PainterProxy.getInstance().setPainterSetting(DEFINE.OPERATE.HIGHLIGHTER, data.painterSetting.highlighter);
        PainterProxy.getInstance().setPainterSetting(DEFINE.OPERATE.LASER_POINTER, data.painterSetting.laserPointer);


        store.currentBookPage = data.currentBookPage;
        store.currentStudyPage = data.currentStudyPage;

        // 還原設定
        settingStore.isFixed = Number(data.isFixed);
        // 還原滑鼠設定
        store.cursorSetting = data.cursorSetting;
        EventBus.getInstance().emit("load_cursor_data", data.cursorSetting);
        // 還原印章
        store.stampCustomPage = data.stampCustomPage;
        store.stampCustomIndex = data.stampCustomIndex;
        EventBus.getInstance().getAppRefs().stampBoard.getUserCustom();
        // 讀取引用的圖片
        ImageControl.Instance.loadData(data.images);
    }
    /**
     * 
     * @param {String} recordId 
     * @param {String} recordName 
     * @param {String} filePath 
     * @param {String} updateTime 
     */
    deleteUserRecord(recordId, recordName, filePath, updateTime) {
        const self = this;
        this._confirmDialog.showDialog(
            "提示",
            `將會刪除以下存檔 ${recordName}`,
            () => {
                store.updateUserRecord = true;
                AppRenderer.Instance.deleteRecord(recordId, recordName, filePath, updateTime);
            },
            null
        );
        //AppRenderer.Instance.deleteRecord(recordId, recordName, filePath, updateTime);
    }

    mergeRecordToCloud(data) {
        const task = {};
        task.taskName = store.nowLogName;
        task.taskType = RECORD_TASK_TYPE.UPLOAD_TO_CLOUD;
        task.updateTime = element.update_time;
        task.url = element.file_path;
    }

    startAutoSaveLocal() {
        return () => {
            this.handleAutoSaveLocal();
        };
    }

    handleAutoSaveLocal() {
        const data = this.getSaveData();

        Debugger.Instance.log(data, "save_tool");
        // const data = JSON.stringify(PainterProxy.getInstance().getMainPainterSaves());

        this._messageDialog.showDialog("紀錄進度", "自動存檔中...");

        AppRenderer.Instance.autoSaveLocal(data);
    }
    //#endregion

    //#region 登入/登出使用者
    handleLogin() {
        const self = this;
        return () => {
            const USER_DATA = useUserStore();
            if (USER_DATA.userId.length > 0) {
                // logout
                store.mergeToCloud = false;
                self.logout();
            } else {
                // login
                console.log("login");
                self._loginTypeDialog.show = true;
            }
        };
    }
    logout() {
        const USER_DATA = useUserStore();
        USER_DATA.userId = "";
        USER_DATA.userName = "";
        USER_DATA.token = "";
    }
    //#endregion

    //#region 儲存視窗操作
    setSaveDialogRecordName(recordName) {
        this._saveDialog.setRecordName(recordName);
    }
    //#endregion

    //#region 儲存紀錄特別處理
    /**
     * record parse to save
     * @param {Array} record 
     * @returns 
     */
    recordParse(record) {
        const tempRecord = [];
        record.forEach(element => {
            let pageRecord = JSON.parse(element.save);
            //console.log("page record:", pageRecord);
            pageRecord.objects.forEach(obj => {
                if (obj.toolType == "insert_picture") {
                    obj.src = obj.imageFileName;
                } else if (obj.toolType == "sticky") {
                    obj.objects.forEach(item => {
                        if (item.type == "image") {
                            item.src = item.src.substring(item.src.indexOf("image"));
                        }
                    });
                } else if (obj.toolType == "web_link") {
                    obj.objects.forEach(item => {
                        if (item.type == "image") {
                            item.src = item.src.substring(item.src.indexOf("image"));
                        }
                    });
                } else if (obj.toolType == "graphic_board") {
                    obj.objects.forEach(item => {
                        if (item.type == "image") {
                            item.src = item.src.substring(item.src.indexOf("image"));
                        }
                    });
                } else if (obj.toolType == "stamp") {
                    obj.src = obj.src.substring(obj.src.indexOf("image"));
                }
            });

            let json_string = {
                key: element.key,
                save: JSON.stringify(pageRecord)
            };

            tempRecord.push(json_string);
        });

        return tempRecord;
    }

    recordParseToRead(record, folderPath) {
        let userPaint = [];

        record.forEach(element => {
            let pageRecord = JSON.parse(element.save);
            pageRecord.objects.forEach(obj => {
                if (obj.toolType == "insert_picture") {
                    obj.src = folderPath + obj.imageFileName;
                    console.log("obj.src:", obj.src);
                    AppRenderer.Instance.copyImage(obj.src);
                }
            });

            let json_string = {
                key: element.key,
                save: JSON.stringify(pageRecord)
            };

            userPaint.push(json_string);
        });

        return userPaint;
    }
    //#endregion
}